import { z } from 'zod'

import { AvailableCurrencies } from 'common/settings/constants/AvailableCurrencies'

export const AvailableCurrenciesMapSchema = z.record(z.nativeEnum(AvailableCurrencies), z.string())
